export function isTouch(log = false) {
	if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
		const elemHtml = document.querySelector('html');

		if ( !elemHtml.classList.contains('touch') ) {
			elemHtml.classList.add('touch');
		}

		return true;
	}

	return false;
}